export const environment = {
  apiBasePath: '/api',
  appTitle: 'GEST',
  defaultLang: 'it',
  production: true,
  logoPath: 'assets/tenant/logo.svg',
  favicon: 'assets/tenant/favicon.ico',
  themeColor: '#4caed4',
  vapidPublicKey: 'BDbImhe_IrUMtVPmSQ8eACjE6QHRw2qCWqbns6iIT_kdtbcfoEPXecgul5mIMkvm94c0HPMWvpYnw0dkFRWUVUE',
};
